import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/** Rôle de l'utilisateur, tel que le realm Keycloak le nomme. */
export type UserKind = 'student' | 'professor' | 'supervisor';

/**
 * Bandeau d'identité des tableaux de bord : qui suis-je, et à quel titre.
 *
 * Un même compte peut ouvrir des écrans très différents selon son rôle ;
 * l'afficher évite de le déduire de la barre latérale. Pour un élève, le
 * parcours complète l'information — c'est lui qui détermine ce qu'il voit :
 * matières, tests, supports.
 */
@Component({
  selector: 'app-identity-banner',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './identity-banner.component.html',
  styleUrl: './identity-banner.component.css',
})
export class IdentityBannerComponent {
  @Input({ required: true }) name = '';
  @Input({ required: true }) kind: UserKind = 'student';

  /** Parcours de l'élève. Ignoré pour les autres rôles. */
  @Input() learningPath: string | null = null;

  @Input() avatar = 'assets/images/default-user.png';

  get kindLabelKey(): string {
    switch (this.kind) {
      case 'professor':  return 'IDENTITY.PROFESSOR';
      case 'supervisor': return 'IDENTITY.SUPERVISOR';
      default:           return 'IDENTITY.STUDENT';
    }
  }

  get kindIcon(): string {
    switch (this.kind) {
      case 'professor':  return 'fa-solid fa-chalkboard-user';
      case 'supervisor': return 'fa-solid fa-user-shield';
      default:           return 'fa-solid fa-user-graduate';
    }
  }

  /** Le parcours n'a de sens que pour un élève. */
  get showLearningPath(): boolean {
    return this.kind === 'student' && !!this.learningPath?.trim();
  }
}
